import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import PrimeVue from 'primevue/config'
import router from './router'
import store from './store'
import ToastService from 'primevue/toastservice'
import ConfigLGVue from 'lg-vue-components/config'

import errorHandlerPlugin from './errorHandlerPlugin'
import Toast from 'primevue/toast'
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import InputText from 'primevue/inputtext'
import Calendar from 'primevue/calendar'
import Dropdown from 'primevue/dropdown'
import ProgressSpinner from 'primevue/progressspinner'
import AutoComplete from 'primevue/autocomplete'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Divider from 'primevue/divider'
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'
import TreeTable from 'primevue/treetable'
import Badge from 'primevue/badge'
import Panel from 'primevue/panel'
import Toolbar from 'primevue/toolbar'
import Checkbox from 'primevue/checkbox'
import RadioButton from 'primevue/radiobutton'
import MultiSelect from 'primevue/multiselect'
import InputMask from 'primevue/inputmask'
import Textarea from 'primevue/textarea'

import SlideReferencias from '@/components/slide-referencias/slide-referencias.vue'
import DesconsiderarAtividade from '@/components/desconsiderar-atividade/desconsiderar-atividade.vue'
import CadastrarAtividade from '@/components/cadastrar-atividade/cadastrar-atividade.vue'
import SlideFuncionarios from '@/components/slide-funcionarios/slide-funcionarios.vue'
import Progress from '@/components/progress-spinner/progress.vue'
import AlertaGerarRelatorio from '@/components/AlertaRelatorioGerado.vue'

import 'primevue/resources/themes/lara-light-indigo/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'
import '/node_modules/primeflex/primeflex.css'
import '@/assets/global.scss'

import { Usuarios } from '@/stores/usuarios'

const pinia = createPinia()
const app = createApp(App)

//Forçar deploy
app.use(pinia)

const usuarios = Usuarios()
usuarios.ActionAutenticarContaKeycloak().then(() => {
   instantiateVueApp()
})

function instantiateVueApp() {
   app.use(ConfigLGVue, {
      produto: '',
      rotaPadrao: '/',
      modoAberturaRota: 'path',
      urls: {
         base: '/Autoatendimento',
         produtos: '/Autoatendimento/Produtos'
      },
      cdn: {
         urlBase: 'https://cdn1.lg.com.br',
         versao: '0.0.1'
      },
      zIndex: {
         menu: 99999,
         sidebar: 1000,
         navbar: 1000
      }
   })

   app.use(router)

   app.use(PrimeVue)

   app.use(store)

   app.use(ToastService)

   app.use(errorHandlerPlugin)

   app.component('Toast', Toast)
   app.component('Button', Button)
   app.component('Dialog', Dialog)
   app.component('InputText', InputText)
   app.component('Calendar', Calendar)
   app.component('Dropdown', Dropdown)
   app.component('ProgressSpinner', ProgressSpinner)
   app.component('AutoComplete', AutoComplete)
   app.component('Column', Column)
   app.component('DataTable', DataTable)
   app.component('Divider', Divider)
   app.component('TabView', TabView)
   app.component('TabPanel', TabPanel)
   app.component('TreeTable', TreeTable)
   app.component('Badge', Badge)
   app.component('Panel', Panel)
   app.component('Toolbar', Toolbar)
   app.component('Checkbox', Checkbox)
   app.component('RadioButton', RadioButton)
   app.component('MultiSelect', MultiSelect)
   app.component('InputMask', InputMask)
   app.component('Textarea', Textarea)

   app.component('SlideReferencias', SlideReferencias)
   app.component('DesconsiderarAtividade', DesconsiderarAtividade)
   app.component('CadastrarAtividade', CadastrarAtividade)
   app.component('SlideFuncionarios', SlideFuncionarios)
   app.component('Progress', Progress)
   app.component('AlertaGerarRelatorio', AlertaGerarRelatorio)

   app.mount('#app')
}
